module.exports = __webpack_public_path__ + "static/media/icon6.6371849b.png";